import {useTranslation} from 'react-i18next';
import DateInput from '../../../../../../component/input/dateInput/DateInput';
import TimeInput from '../../../../../../component/input/dateInput/TimeInput';
import {calendar, clock} from '../../../../../../assets/symbols/symbols/Symbols.css';
import ToggledSection from './ToggleSection/ToggledSection';
import * as css from '../PricingStep/PricingStep.css';

function SaleValiditySection() {
    const {t} = useTranslation('subscriptions');

    return (
        <ToggledSection
            icon={calendar}
            titleKey="saleValidity"
            toggleName="activateSaleValidity"
            toggleLabelKey="manualSaleValidity"
            fieldNames={['saleStartDate', 'saleStartTime', 'saleEndDate', 'saleEndTime']}
            helperTitleKey="saleValidityHelperTitle"
            helperContentKey="saleValidityHelperContent"
        >
            <css.inputsRow>
                <css.dateTimeColumn>
                    <DateInput
                        icon={calendar}
                        name="saleStartDate"
                        text={t('saleStartDate')}
                        onChange={() => {}}
                        className={undefined}
                        descText={undefined}
                        readOnly={undefined}
                        isFixed={true}
                    />
                </css.dateTimeColumn>
                <css.dateTimeColumn>
                    <TimeInput
                        icon={clock}
                        name="saleStartTime"
                        text={t('saleStartTime')}
                        onChange={() => {}}
                        className={undefined}
                        descText={undefined}
                        readOnly={undefined}
                        isTimestamp={true}
                        isFixed={true}
                    />
                </css.dateTimeColumn>
            </css.inputsRow>
            <css.inputsRow>
                <css.dateTimeColumn>
                    <DateInput
                        icon={calendar}
                        name="saleEndDate"
                        text={t('saleEndDate')}
                        onChange={() => {}}
                        className={undefined}
                        descText={undefined}
                        readOnly={undefined}
                        isFixed={true}
                    />
                </css.dateTimeColumn>
                <css.dateTimeColumn>
                    <TimeInput
                        icon={clock}
                        name="saleEndTime"
                        text={t('saleEndTime')}
                        onChange={() => {}}
                        className={undefined}
                        descText={undefined}
                        readOnly={undefined}
                        isTimestamp={true}
                        isFixed={true}
                    />
                </css.dateTimeColumn>
            </css.inputsRow>
        </ToggledSection>
    );
}

export default SaleValiditySection;

